<template>
  <v-btn
    icon
    class="app-header-back-btn"
    :class="buttonClasses"
    :aria-label="label"
    v-on="$listeners"
  >
    <v-icon color="#6058c8">mdi-arrow-left</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'AppHeaderBackButton',
  props: {
    label: {
      type: String,
      default: 'Go back',
    },
    /** When true, back button stays visible on desktop (detail headers). */
    showOnDesktop: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonClasses() {
      return this.showOnDesktop ? 'header-nav-return' : 'back-btn';
    },
  },
};
</script>
